import {Component, Input} from '@angular/core';

@Component({
    selector: 'app-alert-error',
    templateUrl: './alert-error.component.html',
    styleUrls: ['./alert-error.component.scss'],
    standalone: false
})
export class AlertErrorComponent {
  @Input() isSmall: boolean = false;
}
